import { Pipe, PipeTransform } from '@angular/core';
const Globalize = require('globalize');

@Pipe({
  name: 'localNumber',
})
export class LocalNumberPipe implements PipeTransform {
  transform(value: any, maximumFractionDigits: number | string = 1, minimumFractionDigits: number | string = 1) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const formatter = Globalize.numberFormatter({
      maximumFractionDigits: this.getDigit(maximumFractionDigits),
      minimumFractionDigits: this.getDigit(minimumFractionDigits),
    });
    return formatter(typeof value === 'string' ? parseFloat(value) : value);
  }

  private getDigit(value: number | string): number {
    return typeof value === 'string' ? (value != null && !isNaN(parseInt(value, 10)) ? parseInt(value, 10) : 1) : value;
  }
}
